import React, { useEffect, useState } from "react";
import {
  Layout,
  Input,
  Row,
  Avatar,
  Popover,
  Button,
  Typography,
  Col,
  Modal,
  Form,
  Breadcrumb,
  Drawer,
} from "antd";
import newLogoImg from "../images/aoLogo30px.svg";
import newLogosmImg from "../images/AOIcon.svg";
import PageRoute from "./PageRoute";
import "./MainLayout.css";
import Sidemenus from "./Sidemenus";
import { LogoutOutlined, UserOutlined, SyncOutlined, SaveOutlined, MenuOutlined } from "@ant-design/icons";
import { AuthService } from "../Services/AuthService";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Context/UserContext";
import UnAuthRoute from "./UnAuthRoute";
const { Header, Sider, Content } = Layout;

const MainLayout: React.FC = () => {
  const { isAuthenticated, isSuperAdmin, currentUser } = useUser();
  const userName: any = currentUser?.name.get();
  const userEmail: any = currentUser?.email.get();
  const userId: any = currentUser?.id.get();
  const [imagePath, setImagePath] = useState<any>(currentUser?.thumbUrl.get());

  const contentUser = () => {
    return (
      <div style={{ width: 295 }}>
        <Row align="middle" className="mt-3 mb-2 ps-2">
          {imagePath ? (
            <Avatar src={imagePath} className="avatar-user cursor" />
          ) : (
            <Avatar icon={<UserOutlined />} className="avatar-user cursor" />
          )}
          <Col className="ps-2">
            <Typography.Title level={5} className="mb-2" style={{ margin: 0 }}>
              {userName}
            </Typography.Title>
            {userEmail}
          </Col>
        </Row>

        <Row className="py-2 ps-2" align="middle">
          <Col className="cursor">
            <Button
              type="text"
              size="small"
              className="linkcolor"
              icon={<UserOutlined />}
              onClick={() => {
                navigate(`/adminuser/profile/${userId}`);
                setOpenPopover(false);
              }}
            >
              Profile
            </Button>
          </Col>
        </Row>

        {isSuperAdmin() && (
          <Row className="py-2 ps-2" align="middle">
            <Col className="cursor">
              <Button
                type="text"
                size="small"
                className="linkcolor"
                icon={<SyncOutlined />}
                onClick={() => {
                  setOpenChangePassword(true);
                  setOpenPopover(false);
                }}
              >
                Change password
              </Button>
            </Col>
          </Row>
        )}

        <Row className="py-2 ps-2" align="middle">
          <Col className="cursor">
            <Button
              type="text"
              size="small"
              className="linkcolor"
              icon={<LogoutOutlined rotate={-90} />}
              onClick={() => {
                UserLogOut();
                setOpenPopover(false);
              }}
            >
              Logout
            </Button>
          </Col>
        </Row>
      </div>
    );
  };

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const UserLogOut = () => {
    AuthService.logout().then((user) => {
      navigate("/login");
      setImagePath(null);
    });
  };

  const [collapsed, setCollapsed] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const BREAKPOINT = 1190; // Breakpoint for sidebar

  const onCollapse = () => {
    if (width >= BREAKPOINT) {
      setCollapsed((x) => !x);
    }
  };

  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    // var splitPath = location.pathname.split("/");
    if (!isAuthenticated()) {
      navigate("/login");
    }
    else if (isAuthenticated())
      setImagePath(currentUser?.thumbUrl.get())
    window.addEventListener("resize", handleResize, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  useEffect(() => {
    if (width >= 1400) {
      setCollapsed(false);
    } else if (width >= BREAKPOINT) {
      setCollapsed(true);
    }
  }, [width]);

  const logoStyle = {
    display: "flex",
    justifyContent: collapsed ? "center" : "start",
    paddingLeft: collapsed ? "0px" : "20px",
    alignItems: "center",
    height: "44px",
  };

  // Calculate layout margins based on width and collapsed state
  const getLayoutStyle = () => {
    if (width < BREAKPOINT) {
      // Mobile/Tablet: No sidebar margin
      return { width: "100%", marginLeft: "0" };
    } else if (collapsed) {
      // Desktop collapsed
      return { width: "calc(100% - 60px)", marginLeft: "60px" };
    } else {
      // Desktop expanded
      return { width: "calc(100% - 240px)", marginLeft: "240px" };
    }
  };

  // Calculate drawer width based on screen size
  const getDrawerWidth = () => {
    if (width < 600) {
      return 160;
    } else if (width < 768) {
      return 180;
    } else if (width < 1000) {
      return 200;
    } else {
      return 220;
    }
  };

  return (
    <React.Fragment>
      {/* Password Change Modal */}
      <Modal
        destroyOnClose
        title="Change password"
        width="400px"
        open={openChangePassword}
        onCancel={() => {
          setOpenChangePassword(false);
          form.resetFields();
        }}
        onOk={() => { }}
        footer={
          <Button
            className="mt-2"
            type="primary"
            size="middle"
            loading={btnLoading}
            onClick={() => {
              form.validateFields().then(async (values: any) => {
                if (userId !== undefined || userId !== "" || userId !== null) {
                  let res = await AuthService.changePassword(
                    userId,
                    values?.currentPassword,
                    values?.newPassword,
                    values?.confirmPassword
                  );
                  if (res) {
                    setOpenChangePassword(false);
                    form.resetFields();
                  }
                }
              });
            }}
          >
            <SaveOutlined /> Submit
          </Button>
        }
      >
        <Form
          form={form}
          name="change-password"
          labelCol={{ span: 12 }}
          wrapperCol={{ span: 12 }}
          autoComplete="off"
          colon={false}
          size="small"
        >
          <Row className="border-bottom" style={{ marginBottom: 18 }}></Row>
          <Form.Item
            label="Current password"
            name="currentPassword"
            labelAlign="left"
            className="form-item-input"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input.Password className="borderLessInput w100" />
          </Form.Item>

          <Form.Item
            label="New password"
            name="newPassword"
            labelAlign="left"
            className="form-item-input"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input.Password className="borderLessInput w100" />
          </Form.Item>

          <Form.Item
            label="Confirm password"
            name="confirmPassword"
            labelAlign="left"
            className="form-item-input"
            rules={[
              { required: true, message: "This field is required" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password className="borderLessInput w100" />
          </Form.Item>
        </Form>
      </Modal>

      {isAuthenticated() ? (
        <Layout hasSider>
          {/* Sidebar - Only visible on screens >= 1150px */}
          {width >= BREAKPOINT && (
            <Sider
              trigger={null}
              collapsible
              collapsed={collapsed}
              style={{
                backgroundColor: "#fff",
                overflow: "auto",
                height: "100vh",
                position: "fixed",
                left: 0,
                top: 0,
                bottom: 0,
                zIndex: 2,
              }}
            >
              <div className="logo" style={logoStyle}>
                <img
                  style={{
                    height: collapsed ? "28px" : "55px",
                    width: collapsed ? "auto" : "200px",
                    marginTop: collapsed ? 1 : 25,
                  }}
                  src={collapsed ? newLogosmImg : newLogoImg}
                  className="cursor"
                  alt="Logo"
                  onClick={onCollapse}
                />
              </div>
              <Sidemenus
                isCollapse={collapsed}
                onsetSlide={() => { }}
                styles={undefined}
                isSlide={false}
              />
            </Sider>
          )}

          {/* Mobile Sidebar Drawer - For screens < 1150px */}
          <Drawer
              className="sidebar-drawer"
              title={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",

                }}
              >
                <img
                  src={newLogoImg}
                  alt="Logo"
                  style={{
                    height: 32,
                    width: "auto",
                  }}
                />
                <Button
                  type="text"
                  icon={
                    <MenuOutlined style={{ fontSize: 18, color: "#4285f4" }} />
                  }
                  onClick={() => setSidebarOpen(false)}
                  style={{
                    width: 36,
                    height: 36,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </div>
            }
            placement="left"
            onClose={() => setSidebarOpen(false)}
            open={sidebarOpen}
            width={getDrawerWidth()}
            closable={false}
          >


            <Sidemenus
              isCollapse={false}
              onsetSlide={() => setSidebarOpen(false)}
              styles={undefined}
              isSlide={false}
            />
          </Drawer>

          {/* Main Content Layout */}
          <Layout
            className="site-layout"
            style={getLayoutStyle()}
          >
            <Header className="site-layout-background aoa-layout">
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                {/* Hamburger Menu Icon - Only show on screens < 1150px */}
                {width < BREAKPOINT && (
                  <Button
                    type="text"
                    icon={<MenuOutlined style={{ fontSize: "18px" }} />}
                    onClick={() => setSidebarOpen(true)}
                    style={{ padding: 0 }}
                  />
                )}
                {/* Collapse/Expand Icon - Only show on screens >= 1150px */}
                {width >= BREAKPOINT && (
                  <Button
                    type="text"
                    icon={<MenuOutlined style={{ fontSize: "18px" }} />}
                    onClick={onCollapse}
                    style={{ padding: 0 }}
                  />
                )}
                <div className="appheading">
                  {isSuperAdmin() ? "Acting Office - Super Admin" : "Acting Office - Sub Admin"}
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Popover
                  placement="bottomRight"
                  content={contentUser}
                  trigger="click"
                  open={openPopover}
                  onOpenChange={(val: boolean) => {
                    setOpenPopover(val);
                  }}
                >
                  <Avatar
                    icon={<UserOutlined />}
                    className="avatar-user"
                    src={imagePath}
                    style={{ cursor: "pointer" }}
                  />
                </Popover>
              </div>
            </Header>
            <Content
              className="site-layout-background"
              style={{
                margin: "2px 0px",
              }}
            >
              {<PageRoute />}
            </Content>
          </Layout>
        </Layout>
      ) : (
        <Layout className="site-layout">
          <Content>
            <UnAuthRoute />
          </Content>
        </Layout>
      )}
    </React.Fragment>
  );
};

export default MainLayout;

interface BreadCrumbItem {
  label: string | React.ReactNode;
  path?: string;
  style?: React.CSSProperties;
}

interface BreadcrumbItemProps {
  item: BreadCrumbItem[];
  separator?: React.ReactNode;
  style?: React.CSSProperties;
}

export const PageHeader = ({ item, separator, style }: BreadcrumbItemProps) => {
  const navigate = useNavigate();
  return (
    <>
      <Breadcrumb style={style ?? { color: "#1677FF" }} separator={separator ?? ">"}>
        {item?.map((item, index) => (
          <Breadcrumb.Item key={index}>
            {item?.path ? (
              <span
                style={item?.style ?? { color: "#0093FF" }}
                onClick={() => {
                  if (item?.path) navigate(item?.path);
                }}
              >
                {item?.label}
              </span>
            ) : (
              item?.label
            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </>
  );
};